import type { AuthSession } from "./types";
import { authenticatedFetch } from "./auth";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL as string | undefined;

export type MessageTranscription = {
  messageId: string;
  conversationId?: string;
  transcriptionStatus: "queued" | "in_progress" | "completed" | "failed";
  transcriptionJobName?: string;
  transcriptionProvider?: "openai";
  transcriptionModel?: "gpt-transcribe";
  transcriptionLanguage?: string;
  transcriptionError?: string;
  transcript?: string;
};

export async function startRemoteAudioTranscription(
  conversationId: string,
  messageId: string,
  session: AuthSession,
) {
  if (!API_BASE_URL) throw new Error("API_NOT_CONFIGURED");
  const response = await authenticatedFetch(
    `${API_BASE_URL}/bridge/transcriptions/${encodeURIComponent(conversationId)}/${encodeURIComponent(messageId)}`,
    session,
    {
      method: "POST",
    },
  );
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    const code = typeof body?.error === "string" ? body.error : `HTTP_${response.status}`;
    throw new Error(code);
  }
  return body as {
    item: MessageTranscription;
    alreadyCompleted?: boolean;
    alreadyRunning?: boolean;
  };
}
